var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-container-simple"},[_c('div',{staticClass:"index-context"},[_c('span',{staticClass:"title1"},[_vm._v("Welcome")]),_c('br'),_c('span',{staticClass:"title"},[_vm._v("欢迎进入"+_vm._s(_vm.VUE_APP_PLATFORM_NAME))])])])}
var staticRenderFns = []

export { render, staticRenderFns }